module.exports = __webpack_public_path__ + "static/media/pasticceria_3.c1f57a7c.jpg";